import {Component} from '@angular/core';
import { LoginInfoComponent } from '../../../shared/components/login-info/login-info.component';
import { SignUpRequestComponent } from '../../components/sign-up-request/sign-up-request.component';

@Component({
    selector: 'app-sign-up-page',
    templateUrl: './sign-up-page.component.html',
    imports: [LoginInfoComponent, SignUpRequestComponent],
})
export class SignUpPageComponent {}
